/**
 * @fileoverview PostHog React context, outside provider.tsx so that file
 * exports only components (react-refresh/only-export-components).
 * @module utils/posthog/context
 */

import type posthog from "posthog-js";
import { createContext } from "react";

export type PostHogClient = typeof posthog | null;
export const PostHogContext = createContext<PostHogClient>(null);
